import { render, staticRenderFns } from "./StickerDetail.vue?vue&type=template&id=199acfa9&scoped=true"
import script from "./StickerDetail.vue?vue&type=script&lang=js"
export * from "./StickerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199acfa9",
  null
  
)

export default component.exports